import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddPhoneActions from './add-phone.actions';

export const addPhoneFeatureKey = 'addPhone';

export interface AddPhoneState {
   callState: CallState;
}

export const initialState: AddPhoneState = {
   callState: LoadingState.Init,
};

const addExtensionReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddPhoneActions.savePhone, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddPhoneActions.savePhoneSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddPhoneActions.savePhoneFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddPhoneState | undefined, action: Action) {
   return addExtensionReducer(state, action);
}
